import { ICreateClientRequest } from "../../../model/base/request/create-client-request";
import { IListClientsRequest } from "../../../model/base/request/list-clients-request";
import HttpClient from "../../services/http-client";
import ApplicationAppService from "../application-app-service";
import { IClientDetailResponse } from "../../../model/base/response/client-detail-response";
import { serialize } from "object-to-formdata";
import { IUpdateClientRequest } from "../../../model/base/request/update-client-request";
import { PaginationResponse } from "../../../model/base/response/pagination-response";
import { IListClientsResponse } from "../../../model/official-daily/response/list-clients-response";

const defaultPath = 'Client';

let applicationData = ApplicationAppService.getApplicationData();

var baseUrl = applicationData.officialDailyUrl;



const listClients = async (params: IListClientsRequest): Promise<PaginationResponse<IListClientsResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}`,
        params: params
    }).then((response) => Object.assign(new PaginationResponse<IListClientsResponse>(), response.data));
};

const getClientById = async (id: number): Promise<IClientDetailResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/${id}`
    }).then((response) => Object.assign({} as IClientDetailResponse, response.data));
};

const createClient = async (params: ICreateClientRequest, brandLogo: File | null): Promise<IClientDetailResponse> => {
    const formData = serialize(params, { indices: false, nullsAsUndefineds: false, booleansAsIntegers: false, allowEmptyArrays: false, noFilesWithArrayNotation: false, dotsForObjectNotation: false });

    if (brandLogo) {
        formData.append("brandLogo", brandLogo);
    }
    return await HttpClient.executeRequest({
        method: 'post',
        baseURL: baseUrl,
        data: formData,
        url: `/${defaultPath}`,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    }).then((response) => Object.assign({} as IClientDetailResponse, response.data));
};

const updateClient = async (params: IUpdateClientRequest, brandLogo: File | null): Promise<IClientDetailResponse> => {

    const formData = serialize(params, { indices: false, nullsAsUndefineds: false, booleansAsIntegers: false, allowEmptyArrays: false, noFilesWithArrayNotation: false, dotsForObjectNotation: false });

    if (brandLogo) {
        formData.append("brandLogo", brandLogo);
    }

    return await HttpClient.executeRequest({
        method: 'put',
        baseURL: baseUrl,
        data: formData,
        url: `/${defaultPath}/${params.id}`,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    }).then((response) => Object.assign({} as IClientDetailResponse, response.data));
};

const enableDisableClient = async (clientId: number, isActive: boolean): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'patch',
        baseURL: baseUrl,
        url: `/${defaultPath}/${clientId}/status`,
        data: { clientId, isActive }
    });
};


const ClientAppSerivce = {
    listClients, getClientById, createClient, updateClient, enableDisableClient
};

export default ClientAppSerivce;